import { FC } from "react";
import { LegacyDesktopLayout, LegacyMobileLayout } from "./legacy";

interface MainLayoutProps {
    children?: React.ReactNode;
}
export const MainLayout: FC<MainLayoutProps> = ({
    children = null,
}) => {
    if (document.documentElement.clientWidth >= 1024) {
        return (
            <LegacyDesktopLayout>
                {children}
            </LegacyDesktopLayout>
        )
    }

    return (
        <LegacyMobileLayout>
            {children}
        </LegacyMobileLayout>
    );
}